export default __webpack_public_path__ + "static/media/colored_bricks.50957b0d.png";